import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { ShieldAlert, Check, Undo2, Clock, Download } from "lucide-react";
import { TOKEN_KEY } from "../lib/mw";
import { toast } from "sonner";

export default function DeleteRequests() {
  const [rows, setRows] = useState([]);
  const [approve, setApprove] = useState(null); // request obj
  const [pass, setPass] = useState("");

  const load = () => api.get("/delete-requests").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const doApprove = async () => {
    try {
      const r = await api.post(`/delete-requests/${approve.id}/approve`, { password: pass });
      toast.success(`${r.data.deleted} KAYIT YEDEKLENİP KALICI SİLİNDİ`);
      setApprove(null); setPass(""); load();
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const doReject = async (id) => {
    try { await api.post(`/delete-requests/${id}/reject`); toast.success("VERİ GERİ GETİRİLDİ"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };

  const STATUS = {
    pending: { l: "ONAY BEKLİYOR", c: "bg-amber-500/20 text-amber-300" },
    approved: { l: "ONAYLANDI (SİLİNDİ)", c: "bg-rose-500/20 text-rose-300" },
    rejected: { l: "REDDEDİLDİ (GERİ GELDİ)", c: "bg-emerald-500/20 text-emerald-300" },
    cancelled: { l: "FİRMA GERİ ALDI", c: "bg-slate-600 text-slate-200" },
  };

  return (
    <div className="mw-fade-up space-y-4" data-testid="delete-requests-page">
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-7 w-7 text-rose-400" />
        <div>
          <h1 className="font-head text-3xl font-bold tracking-tight text-white">SİLME ONAYLARI</h1>
          <p className="text-sm text-slate-400">FİRMALARIN "TÜMÜNÜ SİL" TALEPLERİ. NİHAİ SİLME + YEDEKLEME ANA ADMİNDE.</p>
        </div>
      </div>

      <div className="rounded-xl border border-rose-900/40 bg-rose-950/20 p-4 text-sm text-rose-200">
        Talep onaylanınca veriler önce <b>YEDEKLENİR</b> sonra kalıcı silinir. Reddedilirse veriler firmaya <b>GERİ GETİRİLİR</b>.
        Firma, talebi ilk 1 gün içinde kendisi de geri alabilir.
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 bg-slate-800/50 text-left text-xs uppercase tracking-wider text-slate-400">
              <th className="px-4 py-3">FİRMA</th><th className="px-4 py-3">YIL</th><th className="px-4 py-3">TALEP EDEN</th>
              <th className="px-4 py-3 text-right">KAYIT</th><th className="px-4 py-3">TARİH</th><th className="px-4 py-3">DURUM</th><th className="px-4 py-3 text-right">İŞLEM</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-500">SİLME TALEBİ YOK</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`delreq-${r.id}`} className="border-b border-slate-800/60">
                <td className="px-4 py-2.5 font-semibold text-slate-200">{r.tenant_name || r.tenant_id}</td>
                <td className="px-4 py-2.5 text-slate-400">{r.year || "-"}</td>
                <td className="px-4 py-2.5 text-slate-300">{r.requested_by}</td>
                <td className="px-4 py-2.5 text-right font-mono text-slate-200">{r.count}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-slate-500"><Clock className="mr-1 inline h-3 w-3" />{new Date(r.created_at).toLocaleString("tr-TR")}</td>
                <td className="px-4 py-2.5"><span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${(STATUS[r.status] || {}).c}`}>{(STATUS[r.status] || {}).l || r.status}</span></td>
                <td className="px-4 py-2.5 text-right">
                  {r.status === "pending" && (
                    <div className="flex items-center justify-end gap-1">
                      <Button data-testid={`approve-${r.id}`} onClick={() => { setApprove(r); setPass(""); }} size="sm" className="h-8 bg-rose-600 text-white hover:bg-rose-700"><Check className="mr-1 h-3.5 w-3.5" /> ONAYLA & SİL</Button>
                      <Button data-testid={`reject-${r.id}`} onClick={() => doReject(r.id)} size="sm" variant="outline" className="h-8 border-emerald-700 bg-emerald-950/30 text-emerald-300"><Undo2 className="mr-1 h-3.5 w-3.5" /> GERİ GETİR</Button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!approve} onOpenChange={(v) => !v && setApprove(null)}>
        <DialogContent className="max-w-md border-slate-700 bg-slate-900 text-slate-100">
          <DialogHeader><DialogTitle className="font-head flex items-center gap-2 text-rose-300"><ShieldAlert className="h-5 w-5" /> KALICI SİLME ONAYI</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm">
            <p className="text-slate-300"><b>{approve?.tenant_name}</b> firmasına ait <b>{approve?.count}</b> müşteri kaydı önce yedeklenip ardından KALICI silinecek. Bu işlem geri alınamaz.</p>
            <p className="flex items-center gap-1 text-xs text-slate-400"><Download className="h-3.5 w-3.5" /> Silmeden önce otomatik yedek alınır.</p>
            <Input data-testid="approve-password" type="password" placeholder="ANA ADMİN ŞİFRENİZ" value={pass} onChange={(e) => setPass(e.target.value)} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setApprove(null)} className="border-slate-700 bg-slate-800 text-slate-200">VAZGEÇ</Button>
            <Button data-testid="confirm-approve" onClick={doApprove} className="bg-rose-600 text-white hover:bg-rose-700">YEDEKLE & KALICI SİL</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
